import React, { useEffect, useState } from 'react'
import { CMSPageDetails, GetAllFAQ } from '../services/website.services';
import Skeleton from 'react-loading-skeleton';
import RecordNotFound from '../shared/RecordNotFound';
import { Link, useNavigate, useParams, useSearchParams } from 'react-router-dom';

function DynamicWebPage() {
  const [searchParams] = useSearchParams();
  const params = useParams();
  const navigate = useNavigate();
  const pageSlug = searchParams.get("page_slug")
  const [CMSPageData, setCMSPageData] = useState({});
  const [apiLoaded, setApiLoaded] = useState(false);

  useEffect(() => {
    CMSPageDetails(params.slug)
      .then((response) => {
        setApiLoaded(true);
        setCMSPageData(response && response?.data ? response?.data : {});
      })
      .catch((error) => {
        console.log("Error===>", error)
      })
  }, [navigate, params.slug]);

  return (
    <>
      {apiLoaded ?
        Object.entries(CMSPageData)?.length ?
          <div className='faq-pages'>
            <div className="heading-banner-page">
              <div className="container">
                <h1>{CMSPageData?.title}</h1>
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb justify-content-center">
                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">{CMSPageData?.title}</li>
                  </ol>
                </nav>
              </div>
            </div>
            <div className='innerpage-padding'>
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-md-12">
                    {/* <div className="card faq-content"> */}
                      {/* <div className="card-body">
                        <div className="accordion accordion-flush" id="accordionFlushExample"> */}
                      <div dangerouslySetInnerHTML={{
                        __html: CMSPageData?.description ?
                          CMSPageData?.description :
                          <RecordNotFound heading='website.dynamic_page.web_record_not_found_heading' />
                      }}>
                      </div>
                      {/* </div>
                      </div> */}
                    {/* </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          : <RecordNotFound heading='website.dynamic_page.web_record_not_found_heading' />
        :
      
        <section className="section-padding">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-12">
                <div className="card m-5">
                  <div className="card-body">
                    <Skeleton className='rounded-1' height={400} count={1} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      }
    </>
  )
}

export default DynamicWebPage;
